module.exports = __webpack_public_path__ + "img/crud.79595bff.png";